module.exports = __webpack_public_path__ + "img/solution_img.db32e2dc.png";